var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getDefaultStore, } from '../store';
import { isPlainObject } from '../utils';
export function createModel(options) {
    var _a = options.defaultProps, defaultProps = _a === void 0 ? {} : _a, factory = options.factory, getInitialState = options.getInitialState, namespace = options.namespace, namespaceStoreOptionsWithoutInitialState = __rest(options, ["defaultProps", "factory", "getInitialState", "namespace"]);
    if (!namespace) {
        throw new Error("Error creating model: a \"namespace\" option was not supplied. You " +
            "must supply a unique namespace so that Retil can distinguish between " +
            "different models of the same type.");
    }
    var cache = new WeakMap();
    // The same `getStoreInitialState` function must be used across all instances,
    // or the store will complain about different arguments for the same
    // namespace.
    var latestPropsWithDefaults;
    var getStoreInitialState = !getInitialState
        ? undefined
        : function () { return getInitialState(latestPropsWithDefaults); };
    var namespaceStoreOptions = __assign(__assign({}, namespaceStoreOptionsWithoutInitialState), { getInitialState: getStoreInitialState });
    var model = function (instanceProps) {
        if (instanceProps === void 0) { instanceProps = {}; }
        if (!isPlainObject(instanceProps)) {
            throw new Error('Error instantiating model: when calling a model, you must pass a ' +
                ("props object. Instead, a \"" + typeof instanceProps + "\" was received."));
        }
        var exists = cache.has(instanceProps);
        if (exists) {
            return cache.get(instanceProps);
        }
        else {
            var propsWithDefaults = __assign(__assign({}, defaultProps), instanceProps);
            latestPropsWithDefaults = propsWithDefaults;
            // Only instantiate the default store if it is required
            var store = propsWithDefaults.store || getDefaultStore();
            if (!store.canGetNamespaceStore(namespace, namespaceStoreOptions)) {
                throw new Error("Error creating model: two models of the same type were created, without " +
                    "providing a unique \"namespace\" option for each (they both used the value " +
                    ("\"" + namespace + "\".). When creating multiple models of the same type, you'll ") +
                    "need to provide a unique namespace for each so that Retil can tell them " +
                    "apart.");
            }
            var _a = __read(store.getNamespaceStore(namespace, namespaceStoreOptions), 2), outlet = _a[0], dispatch = _a[1];
            var instance = factory(outlet, dispatch, propsWithDefaults);
            cache.set(instanceProps, instance);
            return instance;
        }
    };
    return model;
}
//# sourceMappingURL=model.js.map